const INIT_DEBUG_STATUS = 'scratch-gui/btn-list/INIT_DEBUG_STATUS';
const RUN_PYTHON_FALSE = 'scratch-gui/btn-list/RUN_PYTHON_FALSE';
const RUN_PYTHON_TRUE = 'scratch-gui/btn-list/RUN_PYTHON_TRUE';
const RUN_C_FALSE = 'scratch-gui/btn-list/RUN_C_FALSE';
const RUN_C_TRUE = 'scratch-gui/btn-list/RUN_C_TRUE';
const initialState = {
    isRunPython:false,
    isRunC:false
}
const reducer = function (state, action) {
    
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case INIT_DEBUG_STATUS:
        return Object.assign({},state,{
            isRunPython : false,
            isRunC : false
        })
    case RUN_PYTHON_FALSE:
        return Object.assign({},state,{
            isRunPython : action.isRunPython
        })
    case RUN_PYTHON_TRUE:
        return Object.assign({},state,{
            isRunPython : action.isRunPython
        })
    case RUN_C_FALSE:
        return Object.assign({},state,{
            isRunC : action.isRunC
        })
    case RUN_C_TRUE:
        return Object.assign({},state,{
            isRunC : action.isRunC
        })
    default:
        return state;
    }
}; 

const initDebugStatus = function(){
    return {
        type: INIT_DEBUG_STATUS,
    }
}
const runPythonFalse = function(){
    return {
        type: RUN_PYTHON_FALSE,
        isRunPython: false
    }
}
const runPythonTrue = function(){
    return {
        type: RUN_PYTHON_TRUE,
        isRunPython: true
    }
}
const runCFalse = function(){
    return {
        type: RUN_C_FALSE,
        isRunC: false
    }
}
const runCTrue = function(){
    return {
        type: RUN_C_TRUE,
        isRunC: true
    }
}

export {
    reducer as default,
    initialState as btnListInitialState,
    initDebugStatus,
    runPythonFalse,
    runPythonTrue,
    runCFalse,
    runCTrue
};
